import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Costs = React.lazy(() => import('./index'));
const CostTable = React.lazy(() => import('./costTable'));
const Cost = React.lazy(() => import('./cost'));
const CostDetail = React.lazy(() => import('./costDetail'));
const AddNewCost = React.lazy(() => import('./addNewCost'));
const EditCost = React.lazy(() => import('./editCost'));

export const useCostRoutes = () => {

    return (
        <React.Fragment>
            <Route path="cost" element={<Suspense fallback={<div>منتظر باشید...</div>}><Costs /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CostTable /></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewCost /></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Cost /></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CostDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditCost /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}